import { onboardingActionTypes } from './constants';

export function saveGradeRequest(data: any) {
	return {
		type: onboardingActionTypes.SAVE_GRADE_REQUEST,
		payload: { data },
	};
}

export function saveGradeSuccess(data: any) {
	return {
		type: onboardingActionTypes.SAVE_GRADE_SUCCESS,
		payload: { data },
	};
}

export function saveGradeError() {
	return { type: onboardingActionTypes.SAVE_GRADE_ERROR };
}

export function getGradesRequest() {
	return { type: onboardingActionTypes.GET_GRADES_REQUEST };
}

export function getGradesSuccess(data: any) {
	return {
		type: onboardingActionTypes.GET_GRADES_SUCCESS,
		payload: { data },
	};
}

export function getGradesError() {
	return { type: onboardingActionTypes.GET_GRADES_ERROR };
}

export function savePasswordRequest(password: string, redirectPath: string) {
	return {
		type: onboardingActionTypes.SAVE_PASSWORD_REQUEST,
		payload: { password, redirectPath },
	};
}

export function savePasswordSuccess() {
	return { type: onboardingActionTypes.SAVE_PASSWORD_SUCCESS };
}

export function savePasswordError() {
	return { type: onboardingActionTypes.SAVE_PASSWORD_ERROR };
}

export function saveChildNameRequest(childName: string, redirectPath: string) {
	return {
		type: onboardingActionTypes.SAVE_CHILD_NAME_REQUEST,
		payload: { childName, redirectPath },
	};
}

export function saveChildNameSuccess() {
	return { type: onboardingActionTypes.SAVE_CHILD_NAME_SUCCESS };
}

export function saveChildNameError() {
	return { type: onboardingActionTypes.SAVE_CHILD_NAME_ERROR };
}

export function setReferenceChannel(referenceChannel: string, redirectPath: string) {
	return {
		type: onboardingActionTypes.SET_REFERENCE_CHANNEL,
		payload: { referenceChannel, redirectPath },
	};
}

export function setReferenceChannelSuccess() {
	return { type: onboardingActionTypes.SET_REFERENCE_CHANNEL_SUCCESS };
}

export function setReferenceChannelError() {
	return { type: onboardingActionTypes.SET_REFERENCE_CHANNEL_ERROR };
}
